// All team data in a single JavaScript file
// Import all team member images
import AtulPathak from '../assets/Teams/TeamMembers/WebTeam/Atul_Pathak.jpg';
import AyushTiwari from '../assets/Teams/TeamMembers/WebTeam/Ayush_Tiwari.jpg';
import HrideshMehrotra from '../assets/Teams/TeamMembers/WebTeam/Hridesh_Mehrotra.jpg';
import ManpreetKaur from '../assets/Teams/TeamMembers/WebTeam/Manpreet_Kaur.jpeg';
import GawthamVellore from '../assets/Teams/TeamMembers/GawthamVellore.jpg';
import AdyaSharma from '../assets/Teams/TeamMembers/AdyaSharma.jpg';
import HimanshuTripathi from '../assets/Teams/TeamMembers/Himanshu Tripathi.jpeg';
import ShrutiMayank from '../assets/Teams/TeamMembers/Shruti Mayank.JPG';
import MeenakshiGupta from '../assets/Teams/TeamMembers/WebTeam/MeenakshiGupta.jpeg'
import DHruvMaheshwari from '../assets/Teams/TeamMembers/Dhruv_maheshwari.jpg'
import YashPandey from '../assets/Teams/TeamMembers/WebTeam/yash_pandey.jpg'

import Shreyansh from '../assets/Teams/TeamMembers/ContentTeam/Shreyansh.jpg';
import Ayush from '../assets/Teams/TeamMembers/ContentTeam/Ayush.jpg';
import Aryan from '../assets/Teams/TeamMembers/ContentTeam/Aryan.jpg';
import Shiv from '../assets/Teams/TeamMembers/ContentTeam/Shiv.jpg';
import Mridul from '../assets/Teams/TeamMembers/ContentTeam/Mridul.jpg';
import Aman from '../assets/Teams/TeamMembers/ContentTeam/Aman.jpeg';

import AbhishekKumar from '../assets/Teams/TeamMembers/ResearchDevelopmentTeam/Abhishek_Kumar.jpg';
import KinjalDixit from '../assets/Teams/TeamMembers/ResearchDevelopmentTeam/kinjal_dixit.JPG';
import TavishiSharma from '../assets/Teams/TeamMembers/ResearchDevelopmentTeam/Tavishi_Sharma.jpg';
import YashKeswani from '../assets/Teams/TeamMembers/ResearchDevelopmentTeam/Yash_Keswani.jpg';
import AbhinayKumar from '../assets/Teams/TeamMembers/ResearchDevelopmentTeam/Abhinay_Kumar.jpg';
import Mohammadyusuf from '../assets/Teams/TeamMembers/ResearchDevelopmentTeam/MohammadYusuf.jpeg'
import AkshatMahanth from '../assets/Teams/TeamMembers/ResearchDevelopmentTeam/Akshat_Mahanth_treasurer.jpg'
import YashvardhanSingh from '../assets/Teams/TeamMembers/ResearchDevelopmentTeam/YashvardhanSingh.jpeg'
import DevMani from '../assets/Teams/TeamMembers/ResearchDevelopmentTeam/DevMani.jpeg'
import UtsavPandey from '../assets/Teams/TeamMembers/ResearchDevelopmentTeam/UtsavPandey.jpeg'


import alok from '../assets/Teams/TeamMembers/FieldOfficer/alok.JPG';
import Dhruv from '../assets/Teams/TeamMembers/FieldOfficer/Dhruv.jpg';
import AshutoshSingh from '../assets/Teams/TeamMembers/FieldOfficer/AshutoshSingh.jpeg';
import AshutoshKumar from '../assets/Teams/TeamMembers/FieldOfficer/Ashutosh.jpeg';
import vivek from '../assets/Teams/TeamMembers/FieldOfficer/vivek.jpeg';
import prajjwal from '../assets/Teams/TeamMembers/FieldOfficer/Prajjwal.jpg';
 import neelakshi from '../assets/Teams/TeamMembers/FieldOfficer/neelakshi.jpeg';
// import AdityaRoysha from '../assets/Teams/TeamMembers/FieldOfficer/Aditya.jpeg';
import AnantPandey from '../assets/Teams/TeamMembers/FieldOfficer/AnantPandey.jpg';
import JatinChaudhary from '../assets/Teams/TeamMembers/FieldOfficer/JatinChaudhary.png';
import DivyaMohan from '../assets/Teams/TeamMembers/FieldOfficer/DivyaMohan.jpg';

import SanginiBaingaha from '../assets/Teams/TeamMembers/DesignTeam/Sanginibaingaha .jpeg';
import DivyanshuPurbey from '../assets/Teams/TeamMembers/DesignTeam/DivyanshuPurbey.jpg';
import SanyaGupta from '../assets/Teams/TeamMembers/DesignTeam/SANYAGUPTA.jpg';
import AparajitaSingh from '../assets/Teams/TeamMembers/DesignTeam/AparajitaSingh.jpg';
import ShreyanshRathi from '../assets/Teams/TeamMembers/DesignTeam/Shreyansh Rathi.png';
import AyushGupta from '../assets/Teams/TeamMembers/DesignTeam/Ayush Gupta 2.jpg';
import AryanRaj from '../assets/Teams/TeamMembers/DesignTeam/Aryan_Raj.jpg';
import GaganKumar from '../assets/Teams/TeamMembers/DesignTeam/Gagan Kumar.jpg';
import Palakshi from '../assets/Teams/TeamMembers/DesignTeam/Palakshi.jpg';
import RahulKharwar from '../assets/Teams/TeamMembers/DesignTeam/RahulKharwar.jpg';
import ShreshthGadhwala from  '../assets/Teams/TeamMembers/DesignTeam/ShreshthGadhwala.jpg';
import SuyashRanjan from  '../assets/Teams/TeamMembers/DesignTeam/Suyash Ranjan.jpg';

import HumanshiSingh from '../assets/Teams/TeamMembers/MarketingTeam/HumanshiSingh.jpg';
import ShaghilJawed from '../assets/Teams/TeamMembers/MarketingTeam/ShaghilJawed.jpg';
import NavyaSrivastava from '../assets/Teams/TeamMembers/MarketingTeam/Navya.jpg';
import UjjwalGupta from '../assets/Teams/TeamMembers/MarketingTeam/UjjwalGupta.jpg';
import AashutoshPathak from '../assets/Teams/TeamMembers/MarketingTeam/Aashutosh Pathak.png';
import PragyanAnsh from '../assets/Teams/TeamMembers/MarketingTeam/pragyan ansh.jpg';
import PrakharKumarShandilya from '../assets/Teams/TeamMembers/MarketingTeam/Prakhar Kumar Shandilya.jpg';
import PrabhatShukla from '../assets/Teams/TeamMembers/MarketingTeam/Prabhat Shukla.jpeg';
import BhumitVyas from '../assets/Teams/TeamMembers/MarketingTeam/Bhumit.jpg';

import ShauryaRajSrivastava from '../assets/Teams/TeamMembers/Shaurya Raj Srivastava.jpg';
import AniketShah from '../assets/Teams/TeamMembers/Aniket Shah.jpg';

import defaultImage from '../assets/Teams/TeamMembers/question_mark.jpg';

export const teamData = {
  web: {
    name: "WEB TEAM",
    description: "Building digital solutions and innovative web platforms to amplify our social impact initiatives",
    present: [
      {
        name: "Meenakshi Gupta",
        year: "2026",
        email: "guptameenakshi957@gmail.com",
        linkedin: "https://www.linkedin.com/in/meenakshi-gupta109",
        image: MeenakshiGupta,
        position: "Web Team Head"
      },
      {
        name: "Yash Pandey",
        year: "2026",
        email: "yp5094280@gmail.com",
        linkedin: "https://www.linkedin.com/in/yashpandey02",
        image: YashPandey,
        position: "Developer"
      },
      {
        name: "Dhruv Maheshwari",
        year: "2026",
        email: "dhruvmaheshwari9411@gmail.com",
        linkedin: "https://www.linkedin.com/in/dhruv-maheshwari-12ba7224b",
        image: DHruvMaheshwari,
        position: "Developer"
      },
      {
        name: "Atul Pathak",
        year: "2027",
        email: "atul3pathak@gmail.com",
        linkedin: "https://www.linkedin.com/in/atul-pathak03/",
        image: AtulPathak,
        position: "Developer"
      },
      {
        name: "Ayush Tiwari",
        year: "2027",
        email: "ayusht9919@gmail.com",
        linkedin: "https://www.linkedin.com/in/ayush-tiwari-84a823281?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: AyushTiwari,
        position: "Developer"
      },
      {
        name: "Manpreet Kaur",
        year: "2027",
        email: "preetkaurpawar8@gmail.com",
        linkedin: "https://www.linkedin.com/in/manpreet-kaur-a0a345288/",
        image: ManpreetKaur,
        position: "Developer"
      },
      {
        name: "Hridesh Mehrotra",
        year: "2027",
        email: "hridesh.mehrotra@gmail.com",
        linkedin: "https://www.linkedin.com/in/hrideshmehrotra",
        image: HrideshMehrotra,
        position: "Developer"
      }

    ],
    alumni: [
      {
        name: "Gawtham Vellore",
        year: "2019",
        email: "contact@enactus.com",
        linkedin: "https://www.linkedin.com/in/gawtham-vellore",
        image: GawthamVellore,
        position: "Alumni"
      },
      {
        name: "Adya Sharma",
        year: "2021",
        email: "contact@enactus.com",
        linkedin: "https://www.linkedin.com/in/adya-sharma",
        image: AdyaSharma,
        position: "Alumni"
      },
      {
        name: "Himanshu Tripathi",
        year: "2009",
        email: "contact@enactus.com",
        linkedin: "https://www.linkedin.com/in/himanshu-tripathi",
        image: HimanshuTripathi,
        position: "Alumni"
      },
      {
        name: "Shruti Mayank",
        year: "2022",
        email: "contact@enactus.com",
        linkedin: "https://www.linkedin.com/in/shruti-mayank",
        image: ShrutiMayank,
        position: "Alumni"
      }
    ]
  },

  content: {
    name: "CONTENT TEAM",
    description: "Creating compelling content and strategic communications to tell our story and inspire change",
    present: [
      {
        name: "Sangini Baingaha",
        year: "2026",
        email: "sanginibaingaha@gmail.com",
        linkedin: "https://www.linkedin.com/in/sangini-baingaha",
        image: SanginiBaingaha,
       position: "Content Team Head"
      },
      {
        name: "Divyanshu Purbey",
        year: "2026",
        email: "divyanshu.20222064@mnnit.ac.in",
        linkedin: "https://www.linkedin.com/in/divyanshu-purbey/",
        image: DivyanshuPurbey,
        position: "Content Writer"
      },
      {
        name: "Gagan Kumar ",
        year: "2026",
        email: "gagan16903@gmail.com",
        linkedin: "https://www.linkedin.com/in/gagan-kumar-128007259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image:GaganKumar,
        position: "Content Writer"
      },
      {
        name: "Palakshi singh",
        year: "2026",
        email: "singhpalakshi157@gmail.com",
        linkedin: "https://www.linkedin.com/in/itsmepalakshi/",
        image: Palakshi ,
       position: "Content Writer"
      },
      {
        name: "Rahul kharwar",
        year: "2026",
        email: "rahulkharwar250704@gmail.com",
        linkedin: "https://www.linkedin.com/in/rahul-kharwar-87775526a/",
        image: RahulKharwar,
        position: "Content Writer"
      },
      {
        name: "Shresth Gadhwala",
        year: "2026",
        email: "shresthgadhwala.p@gmail.com",
        linkedin: "https://www.linkedin.com/in/shresth2301/",
        image: ShreshthGadhwala,
        position: "Content Writer"
      },
      {
        name: "Suyash Ranjan ",
        year: "2027",
        email: "Suyash.20221105@mnnit.ac.in",
        linkedin: "https://www.linkedin.com/in/ranjansuyash?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: SuyashRanjan,
        position: "Content Writer"
      },
      {
        name: "Shreyansh Rathi ",
        year: "2027",
        email: "shreyanshrathi123@gmail.com",
        linkedin: "https://www.linkedin.com/in/shreyansh-rathi-b2b430291?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: Shreyansh,
        position: "Content Writer"
      },
      {
        name: "Mridul Prakash Verma ",
        year: "2027",
        email: "mridulprakashverma@gmail.com",
        linkedin: "https://www.linkedin.com/in/mridulmnnit?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: Mridul,
        position: "Content Writer"
      },
      {
        name: "Aryan Raj ",
        year: "2027",
        email: "aryanrj.arya@gmail.com",
        linkedin: "https://www.linkedin.com/in/aryarj?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: Aryan,
        position: "Content Writer"
      },
      {
        name: "Ayush Gupta  ",
        year: "2027",
        email: "nitian.ayush.gupta@gmail.com",
        linkedin: "https://www.linkedin.com/in/ayush-gupta-201a21282?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: Ayush,
        position: "Content Writer"
      },
      {
        name: "Shiv Sharan Shukla",
        year: "2027",
        email: "nitian.ayush.gupta@gmail.com",
        linkedin: "https://www.linkedin.com/in/ayush-gupta-201a21282?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: Shiv,
        position: "Content Writer"
      }
    ],
    alumni: [
      {
        name: "Ayush Aman",
        year: "2022",
        email: "contact@enactus.com",
        linkedin: "https://www.linkedin.com/in/ayush-aman",
        image: Aman,
        position: "Alumni"
      }
    ]
  },

  research: {
    name: "RESEARCH AND DEVELOPMENT",
    description: "Conducting in-depth research and developing sustainable solutions for complex social challenges",
    present: [
       {
        name: "Mohammad Yusuf",
        year: "2026",
        email: "m.yusuf7423@gmail.com",
        linkedin: "http://www.linkedin.com/in/mohammad-yusuf-b72342253",
        image: Mohammadyusuf,
        position: "Reasearch and Devlopment Team Head"
      },
      {
        name: "Akshat Mahanth",
        year: "2026",
        email: "akshatmahantham@gmail.com",
        linkedin: "https://www.linkedin.com/in/akshat-mahanth-b1262924b",
        image: AkshatMahanth,
        position: "Reasearcher"
      },
       {
        name: "Dev Mani Tripathi",
        year: "2026",
        email: "devmanitripathi10@gmail.com",
        linkedin: "https://www.linkedin.com/in/dev-mani-tripathi-70221227b",
        image: DevMani,
        position: "Reasearcher"
      },
      {
        name: "Yashvardhan singh",
        year: "2026",
        email: "yvardhan0711@gmail.com",
        linkedin: "https://www.linkedin.com/in/yashvardhan-singh-82ab03288",
        image: YashvardhanSingh,
        position: "Reasearcher"
      },
      {
        name: "Utsav Pandey",
        year: "2026",
        email: "Utsavpandey004@gnail.com",
        linkedin: "https://www.linkedin.com/in/utsav-pandey-8206a71b1/",
        image: UtsavPandey,
        position: "Reasearcher"
      },
      {
        name: "Abhishek Kumar",
        year: "2027",
        email: "akabhishek2311@gmail.con",
        linkedin: "https://www.linkedin.com/in/abhishek231104",
        image: AbhishekKumar,
        position: "Researcher"
      },
      {
        name: "Kinjal Dixit",
        year: "2027",
        email: "kinjald1207@gmail.com",
        linkedin: "https://www.linkedin.com/in/kinjal-dixit-572797201?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
        image: KinjalDixit,
        position: "Researcher"
      },
      {
        name: "Tavishi Sharma",
        year: "2027",
        email: "tavishi.9905@gmail.com",
        linkedin: "https://www.linkedin.com/in/tavishi-sharma-3615a4239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: TavishiSharma,
        position: "Researcher"
      },
      {
        name: "Yash Keswani",
        year: "2027",
        email: "ykeswani29@gmail.com",
        linkedin: "https://www.linkedin.com/in/yash-keswani-856b45293?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: YashKeswani,
        position: "Researcher"
      },
      {
        name: "Abhinay Kumar",
        year: "2027",
        email: "akumar953667@gmail.com",
        linkedin: "https://www.linkedin.com/in/abhinay-kumar-520369289",
        image: AbhinayKumar,
        position: "Researcher"
      }

    ],
    alumni: []
  },

  field: {
    name: "FIELD OFFICER",
    description: "Implementing projects on ground level and directly engaging with communities to create lasting impact",
    present: [
      {
        name: "Anant Pandey",
        year: "2026",
        email: "anantpandey175@gmail.com",
        linkedin: "http://www.linkedin.com/in/anant-pandey-80991b254",
        image: AnantPandey,
        position: "Field Officer Head"
      },
      
      {
        name: "Divya Mohan Kalhans",
        year: "2026",
        email: "dm.kalhans@gmail.com",
        linkedin: "https://www.linkedin.com/in/divya-mohan-kalhans-15bb3824b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: DivyaMohan,
        position: "Field Officer"
      },
      {
        name: "Jatin Chaudhary",
        year: "2026",
        email: "chaudharyjatin205@gmail.com",
        linkedin: "https://www.linkedin.com/in/jatinchaudhary20?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
        image: JatinChaudhary,
        position: "Field Officer"
      },
      {
        name: "Ashutosh Singh Yadav",
        year: "2027",
        email: "ay182025@gmail.com",
        linkedin: "https://www.linkedin.com/in/ashutosh-singh-yadav-2a462b2a7",
        image: AshutoshSingh,
        position: "Field Officer"
      },
      {
        name: "Dhruv kumar singh",
        year: "2027",
        email: "dhruvkumarsingh911@gmail.com",
        linkedin: "https://www.linkedin.com/in/dhruv-kumar-singh-546363295",
        image: Dhruv,
        position: "Field Officer"
      },
      {
        name: "Vivek Kumar",
        year: "2027",
        email: "vivekkumar72.vv@gmail.com",
        linkedin: "https://www.linkedin.com/in/vivek-kumar-6404202a4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: vivek,
        position: "Field Officer"
      },
      {
        name: "Prajjwal Singh",
        year: "2027",
        email: "prajjwalit24@gmail.com",
        linkedin: "https://www.linkedin.com/in/prajjwal-singh-05a915223",
        image: prajjwal,
        position: "Field Officer"
      },
       {
         name: "Neelakshi Pal",
         year: "2027",
         email: "iamneelakshi03@gmail.com",
         linkedin: "www.linkedin.com/in/neelakshi-pal-486497287",
         image: neelakshi,
         position: "Field Officer"
       },
        {
         name: "Ashutosh Kumar",
         year: "2027",
         email: "kumarashutosh30407@gmail.com",
         linkedin: "http://www.linkedin.com/in/ashutoshkumar8",
         image: AshutoshKumar,
         position: "Field Officer"
       },
      
    ],
    alumni: []
  },

  design: {
    name: "DESIGN TEAM",
    description: "Crafting visual identity and user-centered designs that communicate our mission effectively",
    present: [
      {
        name: "Sangini Baingaha",
        year: "2026",
        email: "sanginibaingaha@gmail.com",
        linkedin: "https://www.linkedin.com/in/sangini-baingaha",
        image: SanginiBaingaha,
       position: "Content Team Head"
      },
      {
        name: "Divyanshu Purbey",
        year: "2026",
        email: "divyanshu.20222064@mnnit.ac.in",
        linkedin: "https://www.linkedin.com/in/divyanshu-purbey/",
        image: DivyanshuPurbey,
        position: "Content Writer"
      },
      {
        name: "Gagan Kumar ",
        year: "2026",
        email: "gagan16903@gmail.com",
        linkedin: "https://www.linkedin.com/in/gagan-kumar-128007259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image:GaganKumar,
        position: "Content Writer"
      },
      {
        name: "Palakshi singh",
        year: "2026",
        email: "singhpalakshi157@gmail.com",
        linkedin: "https://www.linkedin.com/in/itsmepalakshi/",
        image: Palakshi ,
       position: "Content Writer"
      },
      {
        name: "Rahul kharwar",
        year: "2026",
        email: "rahulkharwar250704@gmail.com",
        linkedin: "https://www.linkedin.com/in/rahul-kharwar-87775526a/",
        image: RahulKharwar,
        position: "Content Writer"
      },
      {
        name: "Shresth Gadhwala",
        year: "2026",
        email: "shresthgadhwala.p@gmail.com",
        linkedin: "https://www.linkedin.com/in/shresth2301/",
        image: ShreshthGadhwala,
        position: "Content Writer"
      },
      {
        name: "Suyash Ranjan ",
        year: "2027",
        email: "Suyash.20221105@mnnit.ac.in",
        linkedin: "https://www.linkedin.com/in/ranjansuyash?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: SuyashRanjan,
        position: "Content Writer"
      },
      {
        name: "Shreyansh Rathi ",
        year: "2027",
        email: "shreyanshrathi123@gmail.com",
        linkedin: "https://www.linkedin.com/in/shreyansh-rathi-b2b430291?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: Shreyansh,
        position: "Content Writer"
      },
      {
        name: "Mridul Prakash Verma ",
        year: "2027",
        email: "mridulprakashverma@gmail.com",
        linkedin: "https://www.linkedin.com/in/mridulmnnit?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: Mridul,
        position: "Content Writer"
      },
      {
        name: "Aryan Raj ",
        year: "2027",
        email: "aryanrj.arya@gmail.com",
        linkedin: "https://www.linkedin.com/in/aryarj?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: Aryan,
        position: "Content Writer"
      },
      {
        name: "Ayush Gupta  ",
        year: "2027",
        email: "nitian.ayush.gupta@gmail.com",
        linkedin: "https://www.linkedin.com/in/ayush-gupta-201a21282?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: Ayush,
        position: "Content Writer"
      },
      {
        name: "Shiv Sharan Shukla",
        year: "2027",
        email: "nitian.ayush.gupta@gmail.com",
        linkedin: "https://www.linkedin.com/in/ayush-gupta-201a21282?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: Shiv,
        position: "Content Writer"
      }
    ],
    alumni: []
  },

  marketing: {
    name: "MARKETING AND SPONSORSHIP",
    description: "Building strategic partnerships and promoting our initiatives to expand reach and secure resources",
    present: [
        {
        name: "Ujjwal Gupta",
        year: "2026",
        email: "guptaujjwal2509@gmail.com",
        linkedin: "https://www.linkedin.com/in/ujjwal-gupta25?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image:UjjwalGupta,
        position: "Marketing and Sponsorship Head"
      },
      {
        name: "Shaghil Jawed ",
        year: "2026",
        email: "shaghiljawed76@gmail.com",
        linkedin: "https://www.linkedin.com/in/shaghil-jawed-68989919b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: ShaghilJawed,
        position: "Marketing Specialist"
      },
      {
        name: "Humanshi Singh",
        year: "2026",
        email: "Humanshi Singh",
        linkedin: "https://www.linkedin.com/in/humanshi-singh03/",
        image: HumanshiSingh,
        position: "Marketing Specialist"
      },
      {
        name: "Aashutosh Prasad Pathak",
        year: "2027",
        email: "aashutosh.20232060@mnnit.ac.in",
        linkedin: "https://www.linkedin.com/in/aashutosh-pathak-7383622a7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: AashutoshPathak,
        position: "Marketing Specialist"
      },
      {
        name: "Pragyan Ansh",
        year: "2027",
        email: "pragyanansh001@gmail.com",
        linkedin: "https://www.linkedin.com/in/pragyan-ansh-0b72ab298?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: PragyanAnsh,
        position: "Marketing Specialist"
      },
       {
        name: "Vyas Bhumit",
        year: "2027",
        email: "bhumitvvyas@gmail.com",
        linkedin: "https://www.linkedin.com/in/bhumit-vyas-01a376325?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: BhumitVyas,
        position: "Marketing Specialist"
      },
      {
        name: "Prakhar Kumar Shandilya ",
        year: "2027",
        email: "prakhar4472@gmail.com",
        linkedin: "https://www.linkedin.com/in/prakhar-ks/",
        image: PrakharKumarShandilya,
        position: "Marketing Specialist"
      },
      {
        name: "Prabhat Shukla ",
        year: "2027",
        email: "prabhatshukladva@gmail.com",
        linkedin: "https://www.linkedin.com/in/prabhat-shukla-771968302?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        image: PrabhatShukla,
        position: "Marketing Specialist"
      }
    ],
    alumni: [
      {
        name: "Shaurya Raj Srivastava",
        year: "2021",
        email: "contact@enactus.com",
        linkedin: "https://www.linkedin.com/in/shaurya-raj-srivastava",
        image: ShauryaRajSrivastava,
        position: "Alumni"
      },
      {
        name: "Aniket Shah",
        year: "2020",
        email: "contact@enactus.com",
        linkedin: "https://www.linkedin.com/in/aniket-shah",
        image: AniketShah,
        position: "Alumni"
      }
    ]
  }
};

// Team configuration with metadata
export const teamConfig = {
  web: {
    name: "WEB TEAM",
    description: "Building digital solutions and innovative web platforms to amplify our social impact initiatives",
    data: teamData.web,
    path: "/webTeam"
  },
  research: {
    name: "RESEARCH AND DEVELOPMENT",
    description: "Conducting in-depth research and developing sustainable solutions for complex social challenges",
    data: teamData.research,
    path: "/reserchAndDevelopment"
  },
  content: {
    name: "CONTENT TEAM",
    description: "Creating compelling content and strategic communications to tell our story and inspire change",
    data: teamData.content,
    path: "/contentDepartment"
  },
  field: {
    name: "FIELD OFFICER",
    description: "Implementing projects on ground level and directly engaging with communities to create lasting impact",
    data: teamData.field,
    path: "/fieldOfficer"
  },
  design: {
    name: "DESIGN TEAM",
    description: "Crafting visual identity and user-centered designs that communicate our mission effectively",
    data: teamData.design,
    path: "/designDepartment"
  },
  marketing: {
    name: "MARKETING AND SPONSORSHIP",
    description: "Building strategic partnerships and promoting our initiatives to expand reach and secure resources",
    data: teamData.marketing,
    path: "/marketingAndSponcership"
  }
};

// Helper function to get team data by key
export const getTeamData = (teamKey) => {
  return teamConfig[teamKey]?.data || { present: [], alumni: [] };
};

// Helper function to get team metadata
export const getTeamMetadata = (teamKey) => {
  const team = teamConfig[teamKey];
  return {
    name: team?.name || "Unknown Team",
    description: team?.description || "Team description not available",
    path: team?.path || "/"
  };
};

// Export individual team data for direct access
export const webTeamData = teamData.web;
export const researchTeamData = teamData.research;
export const contentTeamData = teamData.content;
export const fieldTeamData = teamData.field;
export const designTeamData = teamData.design;
export const marketingTeamData = teamData.marketing;
